 import { CheckCircle, Users, TrendingDown, Clock, Shield, Truck } from "lucide-react";
 import { motion } from "framer-motion";
 
 const benefits = [
   {
    icon: Users,
    title: "75+ Partner Locations",
    description: "We've vetted the best suppliers nationwide so you don't have to.",
   },
   {
     icon: TrendingDown,
     title: "Save 20-60% on Every Order",
     description: "Our buying power and used inventory options deliver real savings.",
   },
   {
     icon: Clock,
      title: "Contact in 24 Hours",
      description: "We'll reach out within a day to discuss your project and answer questions.",
   },
   {
     icon: Shield,
     title: "Quality Guaranteed",
     description: "Every system is inspected and verified to meet industry safety standards.",
   },
   {
    icon: Truck,
    title: "Nationwide Delivery",
    description: "Fast shipping coordinated through our network of partner warehouses.",
   },
   {
     icon: CheckCircle,
     title: "Turnkey Solutions",
     description: "From quote to installation—one partner, zero hassle.",
   },
 ];
 
 export function WhyBrokerage() {
   return (
     <section className="py-16 md:py-24 bg-muted">
       <div className="container">
         <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
           {/* Content */}
           <div>
             <span className="inline-block px-4 py-1.5 rounded-full bg-accent/10 text-accent text-sm font-semibold mb-4">
               Why Choose a Broker?
             </span>
             <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
               The Smarter Way to Source Warehouse Racking
             </h2>
             <p className="text-lg text-muted-foreground mb-8">
               Dealing directly with manufacturers means countless calls, quotes, and negotiations. 
               As your broker, we do the heavy lifting—comparing options, ensuring quality, and 
               getting you the best deal every time.
             </p>
 
             <div className="space-y-4">
               {["No more vendor headaches", "We contact you in 24 hours", "Single point of contact", "Quality inspection included"].map((item) => (
                 <div key={item} className="flex items-center gap-3">
                   <div className="flex-shrink-0 w-6 h-6 rounded-full bg-accent/20 flex items-center justify-center">
                     <CheckCircle className="h-4 w-4 text-accent" />
                   </div>
                   <span className="font-medium text-foreground">{item}</span>
                 </div>
               ))}
             </div>
           </div>
 
           {/* Benefits grid */}
           <motion.div 
             className="grid sm:grid-cols-2 gap-4"
             initial="hidden"
             whileInView="visible"
             viewport={{ once: true, margin: "-100px" }}
             variants={{
               hidden: { opacity: 0 },
               visible: {
                 opacity: 1,
                 transition: { staggerChildren: 0.1 },
               },
             }}
           >
             {benefits.map((benefit) => (
               <motion.div
                 key={benefit.title}
                 className="p-5 rounded-xl bg-card border border-border shadow-card"
                 variants={{
                   hidden: { opacity: 0, y: 20 },
                   visible: { opacity: 1, y: 0 },
                 }}
               >
                 <benefit.icon className="h-8 w-8 text-accent mb-3" />
                 <h3 className="font-semibold text-foreground mb-1">{benefit.title}</h3>
                 <p className="text-sm text-muted-foreground">{benefit.description}</p>
               </motion.div>
             ))}
           </motion.div>
         </div>
       </div>
     </section>
   );
 }